module.exports = __webpack_public_path__ + "img/han_jie_gong_zuo_zhan.247eb2b9.png";